/** Sub-page each setting lives on, so a `?setting=` deep link lands correctly. */
export const CSAT_SUBPAGE_BY_SETTING_ID: Readonly<Record<string, string>> = {
  "support/csat/enabled": "general",
  "support/csat/surveyMethods": "general",
  "support/csat/surveySendTime": "general",
  "support/csat/allowRemarks": "general",
  "support/csat/sampleRate": "general",
  "support/csat/allowedInboxEmails": "general",
  "support/csat/emailTemplateId": "template",
  "support/csat/headerImage": "template",
  "support/csat/surveyMessage": "template",
  "support/csat/abTestEnabled": "ab-tests",
  "support/csat/abTestVariants": "ab-tests",
};

/**
 * Sub-page a `?setting=` deep link into the old settings route should land on.
 * Unknown ids fall back to General rather than 404ing.
 */
export function csatSubpage(search: URLSearchParams): string {
  const setting = search.get("setting") ?? "";
  return CSAT_SUBPAGE_BY_SETTING_ID[setting] ?? "general";
}
